import { Checkbox, TableCell, TableRow, Typography } from "@mui/material"
import React from "react"
import { ISspDeal } from "ssp/model"

interface ISspDealRowProps {
  row: ISspDeal
  isSelected: boolean
  disabled: boolean
  isLoadingOperatorsForecast: boolean
  isCreateForm: boolean
  sspIndex: number // used by tests
  sspDealIndex: number // used by tests
  onSelectionChange: (row: ISspDeal, checked: boolean) => any
}

export const SspDealRow = React.memo(
  ({ row, isSelected, disabled, sspIndex, sspDealIndex, onSelectionChange }: ISspDealRowProps) => {
    const id = `ssp-deal-${sspIndex}-${sspDealIndex}`
    return (
      <TableRow
        id={id}
        sx={{
          "& > *": { borderBottom: "unset" }
        }}>
        <TableCell width="1rem">{/* padding left */}</TableCell>
        <TableCell width="1rem">
          <Checkbox
            id={`${id}-checkbox`}
            checked={isSelected}
            disabled={disabled}
            onChange={(_event, checked) => onSelectionChange(row, checked)}
          />
        </TableCell>
        <TableCell>
          <Typography id={`${id}-name`} fontSize=".8rem" color="textPrimary">
            {row.dealid}
          </Typography>
        </TableCell>
        <TableCell>
          <Typography id={`${id}-description`} fontSize=".8rem" color="textSecondary">
            {row.description}
          </Typography>
        </TableCell>
        <TableCell width="1rem">{/* padding right */}</TableCell>
      </TableRow>
    )
  }
)
